/*
 * Shared Insights abbreviation legend. Tables stay dense; this is the full-name map.
 * When you add a new short label in boards / strips / heads, add it here too.
 */

export interface InsightsAbbr {
    short: string;
    full: string;
}

/** Core abbreviations used across Team / Players / H2H / Match boards. */
export const INSIGHTS_ABBREVIATIONS: InsightsAbbr[] = [
    { short: 'Σ', full: 'Filtered total' },
    { short: '6v6', full: 'Even strength' },
    { short: 'PP', full: 'Power play / Extra player' },
    { short: 'EP', full: 'Extra player' },
    { short: 'Pen', full: 'Penalty' },
    { short: 'FB', full: 'Fast break / Counter' },
    { short: 'PK', full: 'Penalty kill' },
    { short: 'G', full: 'Goals' },
    { short: 'Att', full: 'Attempts (shots; for saves = SOG faced)' },
    { short: 'A / As', full: 'Assists' },
    { short: 'S', full: 'Saves' },
    { short: '%', full: 'Conversion or save percentage' },
    { short: 'P/G', full: 'Per game' },
    { short: 'MP', full: 'Matches played' },
    { short: 'ExD', full: 'Exclusions drawn' },
    { short: 'ExC', full: 'Exclusions committed' },
    { short: 'Net', full: 'Exclusion net (drawn - committed)' },
    { short: 'D/C', full: 'Drawn / committed ratio' },
    { short: 'Bl', full: 'Blocks' },
    { short: 'St', full: 'Steals' },
    { short: 'TO', full: 'Turnovers' },
    { short: 'Res', full: 'Result (W / D / L)' },
    { short: 'W-D-L', full: 'Wins - Draws - Losses' },
    { short: 'GF', full: 'Goals for' },
    { short: 'GA', full: 'Goals against' },
    { short: 'SOG', full: 'Shots on goal' },
    { short: 'Q1-Q4', full: 'Quarters' },
    { short: 'OT', full: 'Overtime' },
    { short: 'PS', full: 'Penalty shootout' },
    { short: 'H2H', full: 'Head to head' },
    { short: 'Val', full: 'Valorization score' },
    { short: 'Val/G', full: 'Valorization per game' },
    { short: 'DF', full: 'Direct from foul' },
    { short: 'SO', full: 'Penalty shootout' },
];
